import Settings from './settings';

export { Settings };

export default Settings;
